import React from 'react';
import navbarTeam from './navbarTeam'
import navbarPartnership from './navbarPartnership'
import navbarAllRoles from './navbarAllRoles'
import _ from 'lodash';

const navbarReduce = (profileData) => {
    if (profileData) {
        const { customerprofile, employeeprofile, config: { extraLinks }, permissions } = profileData.user
        const arrayExtraLinks = extraLinks.map(item => (
            {
                id: item.id,
                text: item.anchor,
                icon: (
                    item.icon ?
                        <img width="24" height="24" style={{ marginRight: 9 }} src={item.icon} alt={item.anchor} />
                        :
                        <div style={{ width: 33 }} />
                ),
                path: item.url
            })
        )

        const reducerPermissions = (arrays) => {
            const firstArray = arrays[0]
            arrays[0] = firstArray.filter(item => {
                if (item.id === 'vacations') {
                    return _.includes(permissions, "can_add_leaverequest")
                } else if (item.id === 'expenses') {
                    return _.includes(permissions, "can_add_expenserequest")
                } else {
                    return true
                }
            })
            return arrays
        }

        const reducer = (links, extraLinks) => extraLinks.length > 0 ? [...links, arrayExtraLinks] : links

        if (customerprofile && employeeprofile) {
            return reducer(reducerPermissions(navbarAllRoles), arrayExtraLinks)
        } else if (employeeprofile) {
            return reducer(reducerPermissions(navbarTeam), arrayExtraLinks)
        } else if (customerprofile) {
            return reducer(reducerPermissions(navbarPartnership), arrayExtraLinks)

        }
    }
}
export default navbarReduce